<template>
  <v-text-field
    autocomplete="off"
    class="input-styles e2e-input-email"
    type="email"
    :value="email"
    :rules="rules"
    @blur="blur"
    @input="(val) => update('email', val)"
    height="48"
    label="Email Address"
    placeholder=" "
    outlined
    persistent-placeholder
    required
    :autofocus="autofocus"
    ref="entryForm"
  ></v-text-field>
</template>

<script>
export default {
  name: "EmailInput",
  data() {
    return {
      rules: [],
    };
  },
  methods: {
    emailCheck(value) {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "Invalid e-mail.";
    },
    blur() {
      this.rules = [this.emailCheck, this.requiredCheck];
      //this.$refs.entryForm.validate();
    },
    requiredCheck(value) {
      return !!value || "Required.";
    },
  },
  props: {
    email: String,
    update: Function,
    autofocus: Boolean,
  },
};
</script>
